export default __webpack_public_path__ + "static/artifakt-legend-bold-b27054d322ab7e2613236e2c7c44bcb1.woff";